"use client";
// Imports
import Link from "next/link";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

function navLabel(item) {
  return item?.page?.title || "";
}

function navHref(item) {
  return item?.page?.url || "#";
}

function ColumnLinks({ children }) {
  return (
    <ul className="space-y-1.5">
      {children.map((child, childIndex) => (
        <li key={child?.page?.id || child?.title || childIndex}>
          <Link
            href={navHref(child)}
            className="font-body text-brand-wool text-sm lg:text-[0.95rem] leading-snug hover:text-brand-orange transition-colors"
          >
            {navLabel(child)}
          </Link>
        </li>
      ))}
    </ul>
  );
}

// Footer Nav — accordion on mobile, headed columns from sm up
export function FooterNav({ data }) {
  const { showModeNav, outOfShowModeNav, showModeEnabled } = data;
  const nav = showModeEnabled ? showModeNav : outOfShowModeNav;

  if (!nav?.length) return null;

  const columns = nav.filter((item) => item?.children?.length);
  const flatItems = nav.filter((item) => !item?.children?.length);

  // Render
  return (
    <nav aria-label="Footer" className="flex flex-col gap-8">
      <div className="sm:hidden">
        <Accordion type="single" collapsible className="w-full">
          {columns.map((column, index) => {
            const value = `footer-nav-${index}`;
            return (
              <AccordionItem
                key={column?.page?.id || column?.title || index}
                value={value}
                className="border-brand-wool/20"
              >
                <AccordionTrigger className="font-heading font-heading-sentence text-brand-orange text-lg leading-none py-4 hover:no-underline [&[data-state=open]]:text-brand-orange">
                  {navLabel(column)}
                </AccordionTrigger>
                <AccordionContent className="pb-4">
                  <ColumnLinks>{column.children}</ColumnLinks>
                </AccordionContent>
              </AccordionItem>
            );
          })}
        </Accordion>
      </div>

      <div className="hidden sm:flex sm:flex-row sm:justify-end sm:gap-x-16 lg:gap-x-20">
        {columns.map((column, index) => (
          <div
            key={column?.page?.id || column?.title || index}
            className="min-w-0 sm:w-auto sm:max-w-[13rem]"
          >
            <h3 className="font-heading font-heading-sentence text-brand-orange text-lg lg:text-xl leading-none mb-3 lg:mb-4 w-fit">
              {navLabel(column)}
            </h3>
            <ColumnLinks>{column.children}</ColumnLinks>
          </div>
        ))}
      </div>

      {flatItems.length > 0 && (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-2">
          {flatItems.map((item, index) => (
            <Link
              key={item?.page?.id || item?.title || index}
              href={navHref(item)}
              className="font-body text-brand-wool text-sm lg:text-[0.95rem] leading-snug hover:text-brand-orange transition-colors"
            >
              {navLabel(item)}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}
